export const GRANGE_TRANSLATIONS_EN = {
    breadcrumbs: {
        here: 'You are here:',
        home: 'Home',
    },
    common: {
        add: 'Add',
        back: 'Back',
        cancel: 'Cancel',
        clear: 'Clear',
        close: 'Close',
        collapse: 'Collapse',
        confirm: 'Confirm',
        continue: 'Continue',
        create: 'Create',
        delete: 'Delete',
        done: 'Done',
        dismiss: 'Dismiss',
        edit: 'Edit',
        expand: 'Expand',
        finish: 'Finish',
        from: 'From',
        loading: 'Loading…',
        more: 'More',
        next: 'Next',
        no: 'No',
        off: 'Off',
        on: 'On',
        previous: 'Previous',
        reset: 'Reset',
        remove: 'Remove',
        save: 'Save',
        yes: 'Yes',
    },
    folder: {
        empty: 'No content',
    },
    login: {
        username: 'Username',
        password: 'Password',
        button: {
          login: 'Login',
          token: 'Token',
          forgot: 'Recover',
          register: 'Register'
        },
        'use-token': 'Use token',
    }
};
